import { AdPetType } from '@/graphql/generated/schemas'

export const getSeoKeywordByPetType = (petType: AdPetType) => {
  switch (petType) {
    case 'ALL':
      return { petType: '강아지/고양이', petOwner: '주인님/집사님' }
    case 'CAT':
      return { petType: '고양이', petOwner: '집사님' }
    case 'DOG':
      return { petType: '강아지', petOwner: '주인님' }
    default:
      return { petType: '강아지/고양이', petOwner: '주인님/집사님' }
  }
}
